import authRepo from './../../api/repos/authRepo'

const state = {
  user: null,
  permissions: null,
  roles:null,
  companies:null,
  token: null,
  current_company_id:null
}

const mutations = {
  setAuth: state => {
    state.user = JSON.parse(localStorage.getItem('user'))   
    state.companies = JSON.parse(localStorage.getItem('companies'))
    state.current_company_id = getCompanyId(state.companies)   
    state.token = localStorage.getItem('token')

    if (state.user.roles){
      //state has roles only for current company
      state.roles =  JSON.parse(localStorage.getItem('roles')).filter(role => role.company_id == parseInt(localStorage.getItem('current_company_id')))

      var permissions = [];
      state.roles.forEach(cr => {
        cr.permissions.forEach(p => permissions.push(p))
      })
      state.permissions = permissions
    }  
  },

  clearAuth: state => {
    state.user = null
    state.token = null
    state.permissions = null
    state.roles = null
    state.companies = null
    state.current_company_id = null
  },

  setCurrentCompanyId: (state, payload) => (state.current_company_id = payload)
}

const getters = {
  user: state => state.user,
  permissions: state => state.permissions,
  roles: state => state.roles,
  companies: state => state.companies,
  current_company_id: state => state.current_company_id ,
}

const actions = {
  doCheckAuth: async ({ commit }, credentials) => {
    let { data } = await authRepo.login(credentials)

    setToLocalStorage(data)
    commit('setAuth')
  },

  refreshAuth: async ({ commit }, data) => {

    setToLocalStorage(data)
    commit('setAuth')
  },

 
  doLogout: async ({ commit }) => {
    try {
      await authRepo.logout()
    } finally {
      clearFromLocalStorage()
      commit('clearAuth')
    }
  },

  doLogoutAll: async ({ commit }) => {
    try {
      await authRepo.logoutAll()
    } finally {
      clearFromLocalStorage()
      commit('clearAuth')
    }
  },

  doUpdateAccount: async ({ commit }, user) => {
    let { data } = await authRepo.updateAccount(user)
    setToLocalStorage(data)
    commit('setAuth')
  }
}

const setToLocalStorage = data => {

  if (data.companies) {
    localStorage.setItem('companies', JSON.stringify(data.companies))    
    localStorage.setItem('current_company_id', getCompanyId(data.companies))   
    
  }

  if (data.token) localStorage.setItem('token', data.token)

  localStorage.setItem('user', JSON.stringify(data.user))  

  if (data.user.roles){
    //set all roles for all companies
    localStorage.setItem('roles', JSON.stringify(data.user.roles))
 
    var permissions = [];
    JSON.parse(localStorage.getItem('roles')).forEach(cr => {
      cr.permissions.forEach(p => permissions.push(p))
    })
    localStorage.setItem('permissions', JSON.stringify(permissions))
  }    
}

const clearFromLocalStorage = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  localStorage.removeItem('permissions')
  localStorage.removeItem('roles')
  localStorage.removeItem('companies')
  localStorage.removeItem('current_company_id')
}

const getCompanyId = (companies) => {
  
  if(localStorage.getItem('current_company_id') != undefined && localStorage.getItem('current_company_id') != null){    
    var id = null;
    companies.forEach(c => {     
      if(parseInt(c.id) == parseInt(localStorage.getItem('current_company_id'))){ 
        id = parseInt(c.id)
      }
    })    
    if(id == null){id = companies[0].id}
    return id
  }else{
    return parseInt(companies[0].id)
  }
   
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
